﻿import { toggleVisibility, navFullscreen } from '../utils';

/*
 * Responsive main menu
 */
export function registerNavMenu(): void {
    const SELECTORS = {
        nav: '#nav-menu',
        navToggle: '#nav-menu-toggle',
        navToggleExpand: '.menu-expand',
        navToggleCollapse: '.menu-collapse',
        subnav: '.accordion',
        subnavToggleIcons: '.accordion-expand, .accordion-collapse',
        subnavToggle: '.accordion-toggle',
    };
    const CLASSES = {
        navToggleActive: ['bg-nav', 'font-medium'],
    };

    const $nav = $(SELECTORS.nav);

    function toggleMenu(btn: JQuery<HTMLButtonElement> | HTMLButtonElement, state?: boolean): void {
        const $btn = $(btn);
        state = state ?? $btn.attr('aria-expanded') != 'true';

        $btn.attr('aria-expanded', String(state));
        toggleVisibility($btn.find(SELECTORS.navToggleExpand), !state);
        toggleVisibility($btn.find(SELECTORS.navToggleCollapse), state);

        if (state) {
            $btn.addClass(CLASSES.navToggleActive);
        } else {
            $btn.removeClass(CLASSES.navToggleActive);
        }

        toggleVisibility($nav, state);
        navFullscreen(state);
    }

    // Navigation (close search menu if its open)
    $(SELECTORS.navToggle).on('click', (e: JQuery.ClickEvent, prevent?: boolean) => {
        if (!prevent) {
            $(e.currentTarget).siblings('button').trigger('click', [true]);
            toggleMenu(e.currentTarget);
        } else {
            toggleMenu(e.currentTarget, false);
        }
    });
}

/*
 * Responsive search menu
 */
export function registerNavSearch(): void {
    const SELECTORS = {
        search: '#nav-search',
        toggle: '#nav-search-toggle',
        field: '#search-field',
        expand: '.search-expand',
        collapse: '.search-collapse',
    };
    const CLASSES = {
        toggleActive: ['bg-search', 'font-medium', 'text-body'],
    };

    const $search = $(SELECTORS.search);

    function toggleSearch(btn: JQuery<HTMLElement> | HTMLElement, state?: boolean): void {
        const $btn = $(btn);
        state = state ?? $btn.attr('aria-expanded') != 'true';

        $btn.attr('aria-expanded', String(state));
        toggleVisibility($btn.find(SELECTORS.collapse), state);
        toggleVisibility($btn.find(SELECTORS.expand), !state);

        if (state) {
            $btn.addClass(CLASSES.toggleActive);
        } else {
            $btn.removeClass(CLASSES.toggleActive);
        }

        toggleVisibility($search, state);
        navFullscreen(state);
    }

    // Seach menu (close navigation menu if its open)
    $(SELECTORS.toggle).click((e, prevent?: boolean) => {
        if (!prevent) {
            $(e.currentTarget).siblings('button').trigger('click', [true]);
            toggleSearch(e.currentTarget);
        } else {
            toggleSearch(e.currentTarget, false);
        }
    });
}